<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-layout wrap justify-center py-md-0>
      <v-flex xs12>
        <v-layout wrap justify-center>
          <v-flex xs12 pt-md-2>
            <Carousel />
          </v-flex>
          <v-flex xs12 pt-2 pt-md-4>
            <ExclusiveProducts v-bind:title="title" v-bind:items="items1" />
          </v-flex>
          <v-flex xs12 pt-2 pt-md-4>
            <TrendingProducts />
          </v-flex>
          <v-flex xs12 pt-2 pt-md-4>
            <ExclusiveProducts v-bind:title="title2" v-bind:items="items2" />
          </v-flex>
          <v-flex xs12 pt-2 pb-md-4>
            <ExclusiveProducts v-bind:title="title3" v-bind:items="items" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import axios from "axios";
import Carousel from "./carousel";
import ExclusiveProducts from "./exclusiveProducts";
import TrendingProducts from "./trendingProducts";


export default {
  components: {
    Carousel,
    ExclusiveProducts,
    TrendingProducts,
   
  },
  props: ["storage"],
  data() {
    return {
      appLoading:false,
      title: "Fresh Fruit",
      title2: " Spices",
      title3: "Plants",

      items: [
        {
          image: "c5.png",
          nane: "Strawberry",
          price: "120",
        },
        {
          image: "c2.png",
          nane: "Pomegranate",
          price: "80",
        },
        {
          image: "c7.png",
          nane: "Kiwi",
          price: "80",
        },
        {
          image: "c3.png",
          nane: "Orange",
          price: "100",
        },
        {
          image: "c4.png",
          nane: "Plum",
          price: "70",
        },
        {
          image: "c7.png",
          nane: "Kiwi",
          price: "80",
        },
        {
          image: "c5.png",
          nane: "Strawberry",
          price: "120",
        },
        {
          image: "c6.png",
          nane: "Pomegranate",
          price: "80",
        },
        {
          image: "c7.png",
          nane: "Kiwi",
          price: "80",
        },
      ],
      items1: [
        {
          image: "c7.png",
          nane: "Pomegranate",
          price: "80",
        },
        {
          image: "c2.png",
          nane: "Orange",
          price: "100",
        },
        {
          image: "c4.png",
          nane: "Plum",
          price: "70",
        },
        {
          image: "c5.png",
          nane: "Strawberry",
          price: "120",
        },
        {
          image: "c3.png",
          nane: "Pomegranate",
          price: "80",
        },
        {
          image: "c4.png",
          nane: "Kiwi",
          price: "80",
        },
      ],
      items2: [
        {
          image: "c5.png",
          nane: "Pomegranate",
          price: "80",
        },
        {
          image: "c6.png",
          nane: "Orange",
          price: "100",
        },
        {
          image: "c7.png",
          nane: "Plum",
          price: "70",
        },
        {
          image: "c2.png",
          nane: "Strawberry",
          price: "120",
        },
        {
          image: "c3.png",
          nane: "Pomegranate",
          price: "80",
        },
        {
          image: "c4.png",
          nane: "Kiwi",
          price: "80",
        },
      ],
    };
  },


};
</script>